var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEthicalBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.025 30.325C40.2935 30.114 39.5364 30.0046 38.775 30H11.675C9.57316 30 7.55741 30.835 6.07118 32.3212C4.58495 33.8074 3.75 35.8232 3.75 37.925V38.775C3.75 40.8768 4.58495 42.8926 6.07118 44.3788C7.55741 45.865 9.57316 46.7 11.675 46.7H27.625",
    stroke: "#333333",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7754 15.6758H15.6754C11.7266 15.6758 8.52539 18.8769 8.52539 22.8258V22.8508C8.52539 26.7996 11.7266 30.0008 15.6754 30.0008H34.7754C38.7242 30.0008 41.9254 26.7996 41.9254 22.8508V22.8258C41.9254 18.8769 38.7242 15.6758 34.7754 15.6758Z",
    stroke: "#333333",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2008 3.75H19.2758C15.9759 3.75 13.3008 6.4195 13.3008 9.7125C13.3008 13.0055 15.9759 15.675 19.2758 15.675H31.2008C34.5007 15.675 37.1758 13.0055 37.1758 9.7125C37.1758 6.4195 34.5007 3.75 31.2008 3.75Z",
    stroke: "#333333",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4758 41.9258H56.2508V46.7008C56.2508 49.2336 55.2446 51.6627 53.4536 53.4536C51.6627 55.2446 49.2336 56.2508 46.7008 56.2508H41.9258V51.4758C41.9258 48.943 42.9319 46.5139 44.7229 44.7229C46.5139 42.9319 48.943 41.9258 51.4758 41.9258Z",
    stroke: "#333333",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5001 42.8242C48.1205 41.1186 48.2406 39.2712 47.8464 37.4996C47.4523 35.728 46.5601 34.1059 45.2751 32.8242L41.9001 29.4492L41.0001 30.3492L38.5001 32.8492C37.2097 34.1275 36.314 35.7497 35.9195 37.5226C35.5251 39.2955 35.6485 41.1444 36.2751 42.8492",
    stroke: "#333333",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6 46.725V41.95H32.375C34.8863 41.9498 37.2966 42.9388 39.0841 44.7028C40.8715 46.4668 41.8921 48.8639 41.925 51.375V56.375H37.15C35.8874 56.3751 34.6374 56.1248 33.4721 55.6386C32.3069 55.1524 31.2497 54.44 30.3615 53.5426C29.4734 52.6452 28.7721 51.5806 28.2981 50.4103C27.824 49.2401 27.5868 47.9875 27.6 46.725Z",
    stroke: "#333333",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthicalBlack);
export default __webpack_public_path__ + "static/media/ethicalBlack.be412870bb39aa69255a7d46095c65df.svg";
export { ForwardRef as ReactComponent };